import { createSlice } from "@reduxjs/toolkit"
import { status_slices } from "../../Constants";


export const requests = createSlice({
    name: 'requests',
    initialState: {
        isLoading: true,
        status: status_slices.SUCCESS,
        msg: '',
        catProductsAvaliable: [],
        catRequests: [],
        detailRequest: [],
        detailItems: [],
        detailRequestPDF: [],
        detailItemsPDF: []

    },
    reducers: {

        clearCatalogProductsAv: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.catRequests = [];
        },
        clearRequestsMemory: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.catRequests = [];
            state.detailRequest = [];
            state.detailItems = [];
            state.catProductsAvaliable = [];
        },
        clearRequestsPDF: (state, action) => {
            state.detailRequestPDF = [];
            state.detailItemsPDF = [];
        },
        setProductsAv: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Listado de productos disponibles cargado';
            state.catProductsAvaliable = action.payload.catalog;
        },
        setRequests: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Listado de Ordenes disponibles cargado';
            state.catRequests = action.payload.catalog;
        },
        setDetailRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Orden de compra cargada';
            state.detailRequest = action.payload.detail;
            state.detailItems = action.payload.items;

        },
        setDetailRequestPDF: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.SUCCESS;
            state.msg = 'Orden de compra cargada';
            state.detailRequestPDF = action.payload.detail;
            state.detailItemsPDF = action.payload.items;

        },

        setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.NOT_LOADED;
            state.msg = "";
        },
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        }
    }
});

export const { processRequest,clearRequestsPDF, notProcessRequest, setError, clearRequestsMemory, clearCatalogProductsAv, setProductsAv, setRequests, setDetailRequest,setDetailRequestPDF } = requests.actions;